import { computed, Injectable, signal } from '@angular/core';
import { ProductLoanDashboard, Loan } from '../../../interfaces/responses/loan.interface';

@Injectable()
export class ProductDetailsStore {
  private readonly _productLoanDashboard = signal<ProductLoanDashboard>({
    totalDenied: 0,
    totalApplications: 0,
    totalRepaymentDue: 0,
    productName: '',
  });

  private readonly _productId = signal<string>('');
  private readonly _selectedLoan = signal<Loan | null>(null);

  // Expose as readonly signals for reading
  readonly productLoanDashboard = this._productLoanDashboard.asReadonly();
  readonly productId = this._productId.asReadonly();
  readonly selectedLoan = this._selectedLoan.asReadonly();

  setProductId(id: string) {
    this._productId.set(id);
  }

  setData(data: ProductLoanDashboard) {
    this._productLoanDashboard.set(data);
  }

  setSelectedLoan(loan: Loan) {
    this._selectedLoan.set(loan);
  }

  clearSelectedLoan() {
    this._selectedLoan.set(null);
  }

  // Computed values for easier access
  readonly totalApplications = computed(() => this._productLoanDashboard().totalApplications);
  readonly totalRepaymentDue = computed(() => this._productLoanDashboard().totalRepaymentDue);
  readonly totalDenied = computed(() => this._productLoanDashboard().totalDenied);
  readonly productName = computed(() => this._productLoanDashboard().productName);
}
